
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class App extends Vue {
 @Prop({ default: '' }) readonly imageUrl!: string;
 @Prop({ default: '' }) readonly title!: string;
}
